<template>
  <div class="container">
    <div class="row vh-100">
      <div class="col-sm-12 my-auto">
        <div class="card card-block w-100 mx-auto text-center border-0">
          <div class="card-body">
            <h3 class="mt-4">Please wait - Do not press refresh button or back button...</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  beforeMount() {
    if (this.$msal.isAuthenticated()) {
      this.$router.push({
        name: "Dashboard"
      });
    } else {
      this.$router.push({
        name: "SignIn"
      });
    }
  }
};
</script>
